import { render, staticRenderFns } from "./LgFinderPageAlmoxarifado.vue?vue&type=template&id=2c4fa934"
import script from "./LgFinderPageAlmoxarifado.vue?vue&type=script&lang=js"
export * from "./LgFinderPageAlmoxarifado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports